import { ComputerRegistrationForm } from "./computer-registration-form.tsx";
import type { SelfHostedInstaller } from "./types.ts";

export const selfHostedInstaller: SelfHostedInstaller = {
  components: {
    "iam-write": {
      items: {},
      footer: (context, environmentId, config) => {
        return (
          <ComputerRegistrationForm
            context={context}
            config={config}
            environmentId={environmentId}
          />
        );
      },
    },
  },
};
